import { createSelector } from "@reduxjs/toolkit";
import { useSelectorFactory } from "@src/store";
import { getOfferProducts } from "@src/store/slices/offerProducts";

export const getVariationOfferProducts = (variationId: string) =>
  createSelector(getOfferProducts, (offerProducts) =>
    offerProducts.filter((p) => p.variationId === variationId)
  );
export const useVariationOfferProducts = (variationId: string) =>
  useSelectorFactory(getVariationOfferProducts, variationId);
